export default class AppointmentProtocolRule {
	static constructRequestBody(appointments, ruleName) {
		const ruleTemplate = {
			taskType: 'AppointmentClinicalApproval',
			name: ruleName,
			enabled: true,
			ruleType: 'AutomationRule',
		}

		const appointmentProtocolRules = appointments?.map(
			({ quantity, specialtyId, serviceProviderId }, idx) => ({
				...ruleTemplate,
				order: idx,
				rule: [
					[
						{
							option: 'alreadyApprovedCount',
							type: 'lessThan',
							value: `${quantity}`,
						},
						{
							option: 'requestState',
							type: 'in',
							value: ['2', '3'],
						},
						{ option: 'branch', type: 'in', value: ['AT', 'AV'] },
						{
							option: 'appointmentExpertiseId',
							type: 'in',
							value: [specialtyId],
						},
					],
				],
				output: {
					automate: true,
					metadata: serviceProviderId ? [serviceProviderId] : [],
				},
			})
		)

		return {
			ruleType: 'AutomationRule',
			taskType: 'AppointmentClinicalApproval',
			rules: appointmentProtocolRules,
		}
	}

	static retrieveRuleValues(processProtocols) {
		return processProtocols?.map(({ rule, output }) => {
			const quantity = parseInt(
				rule[0].find(({ option }) => option === 'alreadyApprovedCount')
					?.value?.[0] ?? 0,
				10
			)
			const specialtyId =
				rule[0].find(
					({ option }) => option === 'appointmentExpertiseId'
				)?.value?.[0] ?? ''
			const serviceProviderId = output.metadata?.[0] ?? ''

			return { quantity, specialtyId, serviceProviderId }
		})
	}
}
